import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">Alek Hagopian</div>
        <p className="footer-text">
          I build data and AI systems for companies that need the thing actually shipped. <br />
          When I'm not doing that, I build software of my own.
        </p>
        <div className="footer-badges">
          <span className="footer-badge">Virginia, USA</span>
          <span className="footer-badge">Available for projects</span>
          <span className="footer-badge">Independent</span>
        </div>
        <div className="footer-contact">
          <p>Have a project in mind? Email <a href="mailto:alek@solidly.ai">alek@solidly.ai</a></p>
        </div>
        <div className="footer-links">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/work" className="footer-link">Work</Link>
          <Link to="/apps" className="footer-link">Apps</Link>
          <Link to="/about" className="footer-link">About</Link>
          <a
            href="https://newsletter.alekhagopian.com"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Newsletter
          </a>
          <a href="mailto:alek@solidly.ai" className="footer-link">Contact</a>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Alek Hagopian. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
